import React from 'react';
import { Link } from 'react-router-dom';

interface UcpDetailsListItemProps {
  refNumber: string;
  sum: string;
  link?: string;
}

const UcpDetailsListItem: React.FC<UcpDetailsListItemProps> = ({
  refNumber,
  sum,
  link,
}) => (
  <div className="ucp-details-item">
    <div className="ucp-details-item__title">
      {link ? (
        <Link className="link link--no-border" to={link}>
          {refNumber}
        </Link>
      ) : (
        refNumber
      )}
    </div>
    <div className="ucp-details-item__price">{sum}</div>
  </div>
);

export default UcpDetailsListItem;
